<template>
  <div class="page-parametrage">
    <landing-header />
    <main>

      <!-- HERO -->
      <section class="hero-param">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-param">Paramétrage métier</span>
            <h1 class="hero-title">
              Termoflow s'adapte à<br/>
              <span class="gradient-text-param">votre façon de travailler</span>
            </h1>
            <p class="hero-sub">Vous faites de la chaudière mais pas de PAC ? Vous avez vos propres noms d'interventions, vos points de contrôle, vos travaux habituels ? Paramétrez Termoflow une bonne fois pour toutes — et tout le reste suit.</p>
            <div class="hero-ctas">
              <a href="/contact"><button class="btn-primary-param">Demander une démo</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Toutes les fonctionnalités</a>
            </div>
            <div class="hero-stats">
              <div class="stat-pill"><span class="sv">100%</span><span class="sl">Personnalisable</span></div>
              <div class="stat-pill"><span class="sv">Par appareil</span><span class="sl">Granularité fine</span></div>
              <div class="stat-pill"><span class="sv">1 fois</span><span class="sl">À configurer</span></div>
            </div>
          </div>
          <div class="lg:w-1/2 w-full">
            <!-- Paramétrage mockup -->
            <div class="param-ui">
              <div class="pui-bar">
                <div class="pui-dots"><span class="pd r"></span><span class="pd y"></span><span class="pd g"></span></div>
                <span class="pui-title">Paramètres — Types d'appareils</span>
              </div>
              <div class="pui-body">
                <div class="pui-app-grid">
                  <div class="pui-app active-app"><div class="pui-app-icon active-icon"><i class="fa-solid fa-fire-burner"></i></div><span>Chaudière</span><span class="pui-app-badge on">Activé</span></div>
                  <div class="pui-app active-app"><div class="pui-app-icon active-icon"><i class="fa-solid fa-snowflake"></i></div><span>Climatisation</span><span class="pui-app-badge on">Activé</span></div>
                  <div class="pui-app active-app"><div class="pui-app-icon active-icon"><i class="fa-solid fa-bolt"></i></div><span>PAC</span><span class="pui-app-badge on">Activé</span></div>
                  <div class="pui-app inactive-app"><div class="pui-app-icon"><i class="fa-solid fa-wind"></i></div><span>VMC</span><span class="pui-app-badge off">Désactivé</span></div>
                  <div class="pui-app inactive-app"><div class="pui-app-icon"><i class="fa-solid fa-droplet"></i></div><span>Plomberie</span><span class="pui-app-badge off">Désactivé</span></div>
                  <div class="pui-app inactive-app"><div class="pui-app-icon"><i class="fa-solid fa-solar-panel"></i></div><span>Solaire</span><span class="pui-app-badge off">Désactivé</span></div>
                </div>
                <div class="pui-detail-panel">
                  <div class="pdp-head">
                    <div class="pdp-app-name"><i class="fa-solid fa-fire-burner" style="color:#f97316;"></i> Chaudière gaz / fioul</div>
                    <span class="pdp-badge-on">Activé</span>
                  </div>
                  <div class="pdp-section">
                    <div class="pdp-section-title">Types d'interventions</div>
                    <div class="pdp-tags">
                      <span class="pdp-tag">Entretien annuel</span>
                      <span class="pdp-tag">Dépannage</span>
                      <span class="pdp-tag">Installation</span>
                      <span class="pdp-tag">Mise en service</span>
                      <span class="pdp-tag-add">+ Ajouter</span>
                    </div>
                  </div>
                  <div class="pdp-section">
                    <div class="pdp-section-title">Points de contrôle (attestation)</div>
                    <div class="pdp-checks">
                      <div class="pdp-check"><i class="fa-solid fa-check"></i>Vérification brûleur</div>
                      <div class="pdp-check"><i class="fa-solid fa-check"></i>Nettoyage échangeur</div>
                      <div class="pdp-check"><i class="fa-solid fa-check"></i>Contrôle combustion</div>
                      <div class="pdp-check"><i class="fa-solid fa-check"></i>Vase d'expansion</div>
                    </div>
                  </div>
                  <div class="pdp-section">
                    <div class="pdp-section-title">Tarif contrat d'entretien</div>
                    <div class="pdp-tarif">
                      <span class="pdp-tarif-val">129 €</span>
                      <span class="pdp-tarif-lab">/ an HT</span>
                      <button class="pdp-edit-btn"><i class="fa-solid fa-pencil"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TRUST BAR -->
      <section class="trust-bar">
        <div class="max-w-7xl mx-auto px-4">
          <div class="trust-items">
            <div class="trust-item"><i class="fa-solid fa-toggle-on"></i><span>Types d'appareils à la carte</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-list-check"></i><span>Points de contrôle par appareil</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-euro-sign"></i><span>Tarifs entretien par appareil</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-screwdriver-wrench"></i><span>Travaux & sous-types</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-file-lines"></i><span>Attestations d'entretien auto</span></div>
          </div>
        </div>
      </section>

      <!-- SECTION 1 : TYPES D'APPAREILS -->
      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row gap-16 items-start">
            <div class="lg:w-1/2">
              <div class="section-label-param">Types d'appareils</div>
              <h2 class="section-title">Vous faites de la chaudière, pas de la climatisation ?<br/>Dites-le à Termoflow.</h2>
              <p class="section-sub mb-10">Activez uniquement les types d'appareils que vous gérez. Tout le reste disparaît — vos techniciens ne voient que ce qui les concerne.</p>
              <div class="param-feats">
                <div class="pf-row"><div class="pf-icon"><i class="fa-solid fa-toggle-on"></i></div><div><h4>Activation par appareil</h4><p>Chaudière gaz, fioul, électrique, climatisation split, gainable, PAC air/eau, air/air, etc.. — activez ou désactivez chaque catégorie.</p></div></div>
                <div class="pf-row"><div class="pf-icon"><i class="fa-solid fa-filter"></i></div><div><h4>Propagation automatique</h4><p>Un type désactivé disparaît partout : du catalogue de réservation client, des formulaires d'intervention, du planning, des statistiques. Pas de nettoyage à faire.</p></div></div>
                <!-- <div class="pf-row"><div class="pf-icon"><i class="fa-solid fa-pen-to-square"></i></div><div><h4>Sous-types personnalisables</h4><p>Créez vos propres sous-types : "Chaudière murale", "Chaudière sol condensation", "Chaudière micro-CHP"... aussi précis que vous le souhaitez.</p></div></div> -->
              </div>
            </div>
            <div class="lg:w-1/2">
              <div class="appareils-card">
                <div class="ac-head">Types d'appareils configurés</div>
                <div class="ac-list">
                  <div class="ac-item active-item">
                    <div class="ac-app-icon on-icon"><i class="fa-solid fa-fire-burner"></i></div>
                    <div class="ac-info"><b>Chaudière</b><small>Gaz, fioul, électrique, bois</small></div>
                    <div class="ac-toggle on"><div class="ac-thumb"></div></div>
                  </div>
                  <div class="ac-item active-item">
                    <div class="ac-app-icon on-icon" style="background:#eff6ff;color:#f97316;"><i class="fa-solid fa-snowflake"></i></div>
                    <div class="ac-info"><b>Climatisation</b><small>Split, gainable, cassette</small></div>
                    <div class="ac-toggle on" style="background:#f97316;"><div class="ac-thumb"></div></div>
                  </div>
                  <div class="ac-item active-item">
                    <div class="ac-app-icon on-icon" style="background:#f0fdf4;color:#16a34a;"><i class="fa-solid fa-bolt"></i></div>
                    <div class="ac-info"><b>Pompe à chaleur</b><small>Air/eau, air/air, géothermique</small></div>
                    <div class="ac-toggle on" style="background:#16a34a;"><div class="ac-thumb"></div></div>
                  </div>
                  <div class="ac-item">
                    <div class="ac-app-icon"><i class="fa-solid fa-wind"></i></div>
                    <div class="ac-info"><b>VMC</b><small>Simple flux, double flux</small></div>
                    <div class="ac-toggle off"><div class="ac-thumb off-thumb"></div></div>
                  </div>
                  <div class="ac-item">
                    <div class="ac-app-icon"><i class="fa-solid fa-droplet"></i></div>
                    <div class="ac-info"><b>Plomberie</b><small>Sanitaire, chauffage</small></div>
                    <div class="ac-toggle off"><div class="ac-thumb off-thumb"></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION 2 : INTERVENTIONS & TRAVAUX -->
      <section class="py-24 bg-gray-50 border-y border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="section-label-param text-center">Types &amp; sous-types d'interventions</div>
          <h2 class="section-title text-center">Nommez vos interventions comme vous en avez l'habitude</h2>
          <p class="section-sub text-center mx-auto mb-16">Pas de vocabulaire imposé. Créez vos propres types et sous-types d'interventions par appareil, et vos techniciens retrouvent exactement leurs mots.</p>
          <div class="interv-param-grid">
            <div class="ip-col">
              <div class="ip-col-head"><i class="fa-solid fa-fire-burner"></i> Chaudière</div>
              <div class="ip-group">
                <div class="ip-group-name">Entretien</div>
                <div class="ip-sub">Entretien annuel</div>
                <div class="ip-sub">Entretien contrat</div>
                <div class="ip-sub ip-add">+ Ajouter un sous-type</div>
              </div>
              <div class="ip-group">
                <div class="ip-group-name">Dépannage</div>
                <div class="ip-sub">Dépannage urgent</div>
                <div class="ip-sub">Dépannage standard</div>
                <div class="ip-sub ip-add">+ Ajouter</div>
              </div>
              <div class="ip-group">
                <div class="ip-group-name">Installation</div>
                <div class="ip-sub">Remplacement chaudière</div>
                <div class="ip-sub">Nouvelle installation</div>
              </div>
            </div>
            <div class="ip-col">
              <div class="ip-col-head" style="color:#f97316;"><i class="fa-solid fa-snowflake"></i> Climatisation</div>
              <div class="ip-group">
                <div class="ip-group-name">Installation</div>
                <div class="ip-sub">Pose split mono</div>
                <div class="ip-sub">Pose split multi</div>
                <div class="ip-sub">Pose gainable</div>
              </div>
              <div class="ip-group">
                <div class="ip-group-name">Entretien</div>
                <div class="ip-sub">Entretien annuel</div>
                <div class="ip-sub">Nettoyage filtres</div>
              </div>
              <div class="ip-group">
                <div class="ip-group-name">Dépannage</div>
                <div class="ip-sub">Fuite de gaz</div>
                <div class="ip-sub">Problème électronique</div>
              </div>
            </div>
            <div class="ip-col">
              <div class="ip-col-head" style="color:#16a34a;"><i class="fa-solid fa-bolt"></i> PAC</div>
              <div class="ip-group">
                <div class="ip-group-name">Installation</div>
                <div class="ip-sub">Installation PAC air/eau</div>
                <div class="ip-sub">Installation PAC air/air</div>
              </div>
              <div class="ip-group">
                <div class="ip-group-name">Mise en service</div>
                <div class="ip-sub">Mise en service standard</div>
                <div class="ip-sub">Mise en service + formation</div>
              </div>
              <div class="ip-group">
                <div class="ip-group-name">Entretien</div>
                <div class="ip-sub">Entretien annuel PAC</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION 3 : TRAVAUX & POINTS DE CONTRÔLE -->
      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row gap-16 items-start">
            <div class="lg:w-1/2">
              <div class="section-label-param">Travaux réalisés</div>
              <h2 class="section-title">Vos techniciens cochent ce qu'ils ont fait,<br/>pas ce qu'un ingénieur a inventé</h2>
              <p class="section-sub mb-10">Pour chaque type d'intervention et d'appareil, définissez la liste de travaux possibles. Vos techniciens cochent en 30 secondes — le bon d'intervention est rempli automatiquement.</p>
              <div class="param-feats">
                <div class="pf-row"><div class="pf-icon"><i class="fa-solid fa-list-ul"></i></div><div><h4>Liste de travaux par appareil</h4><p>Définissez les travaux habituels de chaque type d'intervention : "Nettoyage brûleur", "Remplacement vanne 3 voies", "Recharge fluide R32"... Vos mots, pas les nôtres.</p></div></div>
                <div class="pf-row"><div class="pf-icon"><i class="fa-solid fa-mobile-screen-button"></i></div><div><h4>Saisie terrain simplifiée</h4><p>Le technicien coche les travaux réalisés depuis son téléphone. Le bon d'intervention se remplit en temps réel, prêt à être signé par le client.</p></div></div>
              </div>
            </div>
            <div class="lg:w-1/2">
              <div class="section-label-param">Points de contrôle</div>
              <h2 class="section-title">Des attestations d'entretien<br/>sans aucun oubli</h2>
              <p class="section-sub mb-10">Définissez vos points de contrôle réglementaires par type d'appareil. L'attestation est générée automatiquement une fois tous les points validés.</p>
              <div class="points-card">
                <div class="pc-head"><i class="fa-solid fa-fire-burner"></i> Chaudière — Points de contrôle obligatoires</div>
                <div class="pc-list">
                  <div class="pc-item checked"><i class="fa-solid fa-check"></i>Vérification brûleur et électrodes</div>
                  <div class="pc-item checked"><i class="fa-solid fa-check"></i>Nettoyage échangeur primaire</div>
                  <div class="pc-item checked"><i class="fa-solid fa-check"></i>Contrôle et réglage combustion</div>
                  <div class="pc-item checked"><i class="fa-solid fa-check"></i>Vérification vase d'expansion</div>
                  <div class="pc-item checked"><i class="fa-solid fa-check"></i>Contrôle sécurité surpression</div>
                  <div class="pc-item unchecked"><i class="fa-regular fa-circle"></i>Vérification disconnecteur</div>
                  <div class="pc-item unchecked"><i class="fa-regular fa-circle"></i>Analyse gaz de combustion</div>
                </div>
                <div class="pc-footer"><i class="fa-solid fa-file-circle-check"></i> L'attestation est générée automatiquement quand tous les points sont validés</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION 4 : TARIFS CONTRATS -->
      <section class="py-24 bg-gray-50 border-t border-gray-100">
        <div class="max-w-5xl mx-auto px-4 text-center">
          <div class="section-label-param">Tarifs des contrats d'entretien</div>
          <h2 class="section-title">Un tarif différent par type d'appareil ? Pas de problème.</h2>
          <p class="section-sub mx-auto mb-12">Définissez vos tarifs annuels de contrat d'entretien appareil par appareil. Termoflow les applique automatiquement lors de la création d'un contrat.</p>
          <div class="tarif-grid">
            <div class="tarif-card"><div class="tarif-icon" style="color:#f97316;"><i class="fa-solid fa-fire-burner"></i></div><div class="tarif-app">Chaudière</div><div class="tarif-val">129 €</div><div class="tarif-lab">/ an HT</div></div>
            <div class="tarif-card"><div class="tarif-icon" style="color:#f97316;"><i class="fa-solid fa-snowflake"></i></div><div class="tarif-app">Climatisation</div><div class="tarif-val">89 €</div><div class="tarif-lab">/ an HT</div></div>
            <div class="tarif-card"><div class="tarif-icon" style="color:#16a34a;"><i class="fa-solid fa-bolt"></i></div><div class="tarif-app">PAC air/eau</div><div class="tarif-val">159 €</div><div class="tarif-lab">/ an HT</div></div>
            <div class="tarif-card tarif-add"><div class="tarif-icon"><i class="fa-solid fa-plus"></i></div><div class="tarif-app">Ajouter</div></div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-24 text-center bg-white">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-6">Un outil qui s'adapte à vous,<br/>pas l'inverse.</h2>
          <p class="text-xl text-gray-500 mb-10">Configurez Termoflow une fois, pour de bon. Le reste suit automatiquement.</p>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/contact"><button class="btn-primary-large-param">Demander une démonstration</button></a>
            <a href="/fonctionnalites" class="btn-outline-large">Toutes les fonctionnalités</a>
          </div>
        </div>
      </section>
      <landing-roi /><landing-avis />
    </main>
    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'
export default {
  name: 'ParametragePage',
  components: { LandingHeader, LandingFooter, LandingAvis, 'landing-roi': LandingROI }
}
</script>

<style scoped>
.gradient-text-param{background:linear-gradient(to right,#f97316,#f97316);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
.hero-param{padding:10rem 0 6rem;background:radial-gradient(ellipse at top right,#f5f3ff,transparent 50%),radial-gradient(ellipse at bottom left,#eff6ff,transparent 50%);}
.badge-param{display:inline-block;padding:.5rem 1rem;background:#f5f3ff;color:#6d28d9;font-weight:800;font-size:.75rem;border-radius:9999px;margin-bottom:1.5rem;text-transform:uppercase;border:1px solid #ddd6fe;letter-spacing:.05em;}
.hero-title{font-size:clamp(2rem,4vw,3.5rem);font-weight:900;color:#111827;line-height:1.15;margin-bottom:1.25rem;}
.hero-sub{font-size:1.1rem;color:#6b7280;line-height:1.7;margin-bottom:2rem;}
.hero-ctas{display:flex;flex-wrap:wrap;gap:1rem;margin-bottom:2rem;}
.hero-stats{display:flex;flex-wrap:wrap;gap:.75rem;padding-top:1.75rem;border-top:1px solid #f1f5f9;}
.stat-pill{display:flex;flex-direction:column;padding:.65rem 1.15rem;background:white;border:1px solid #e5e7eb;border-radius:9999px;}
.sv{font-size:1rem;font-weight:900;color:#f97316;}
.sl{font-size:.65rem;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.05em;}
/* Param UI mockup */
.param-ui{background:white;border-radius:1.5rem;border:1px solid #e5e7eb;overflow:hidden;box-shadow:0 20px 60px -12px rgba(0,0,0,.1);}
.pui-bar{background:#f8fafc;border-bottom:1px solid #e5e7eb;padding:.85rem 1.25rem;display:flex;align-items:center;gap:.75rem;}
.pui-dots{display:flex;gap:.4rem;}
.pd{width:10px;height:10px;border-radius:50%;}
.pd.r{background:#ef4444;}.pd.y{background:#f59e0b;}.pd.g{background:#22c55e;}
.pui-title{font-size:.75rem;font-weight:800;color:#64748b;}
.pui-body{padding:1.25rem;display:flex;flex-direction:column;gap:1.25rem;}
.pui-app-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:.6rem;}
.pui-app{background:#f8fafc;border:1px solid #e5e7eb;border-radius:.75rem;padding:.75rem;text-align:center;cursor:pointer;}
.pui-app.active-app{background:white;border-color:#e5e7eb;}
.pui-app.inactive-app{opacity:.55;}
.pui-app-icon{width:2rem;height:2rem;border-radius:.5rem;background:#f1f5f9;color:#94a3b8;display:flex;align-items:center;justify-content:center;font-size:.9rem;margin:0 auto .4rem;}
.pui-app-icon.active-icon{background:#fff7ed;color:#f97316;}
.pui-app span{font-size:.7rem;font-weight:700;color:#374151;display:block;margin-bottom:.3rem;}
.pui-app-badge{font-size:.58rem;font-weight:800;padding:.15rem .45rem;border-radius:9999px;display:inline-block;}
.pui-app-badge.on{background:#f0fdf4;color:#166534;}
.pui-app-badge.off{background:#f1f5f9;color:#94a3b8;}
.pui-detail-panel{background:#f8fafc;border:1px solid #e5e7eb;border-radius:1rem;padding:1.1rem;}
.pdp-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:1rem;}
.pdp-app-name{font-size:.85rem;font-weight:800;color:#1e293b;display:flex;align-items:center;gap:.5rem;}
.pdp-badge-on{font-size:.65rem;font-weight:800;padding:.25rem .7rem;border-radius:9999px;background:#f0fdf4;color:#166534;}
.pdp-section{margin-bottom:1rem;}
.pdp-section-title{font-size:.65rem;font-weight:800;color:#94a3b8;text-transform:uppercase;letter-spacing:.06em;margin-bottom:.5rem;}
.pdp-tags{display:flex;flex-wrap:wrap;gap:.4rem;}
.pdp-tag{font-size:.72rem;font-weight:700;background:white;border:1px solid #e5e7eb;color:#374151;padding:.25rem .7rem;border-radius:9999px;}
.pdp-tag-add{font-size:.72rem;font-weight:700;color:#f97316;border:1px dashed #ddd6fe;padding:.25rem .7rem;border-radius:9999px;cursor:pointer;}
.pdp-checks{display:flex;flex-direction:column;gap:.35rem;}
.pdp-check{display:flex;align-items:center;gap:.5rem;font-size:.75rem;font-weight:700;color:#374151;}
.pdp-check i{color:#22c55e;font-size:.65rem;}
.pdp-tarif{display:flex;align-items:center;gap:.6rem;}
.pdp-tarif-val{font-size:1.25rem;font-weight:900;color:#f97316;}
.pdp-tarif-lab{font-size:.75rem;font-weight:700;color:#94a3b8;}
.pdp-edit-btn{margin-left:auto;width:1.75rem;height:1.75rem;border-radius:.4rem;border:1px solid #e5e7eb;background:white;color:#64748b;font-size:.7rem;display:flex;align-items:center;justify-content:center;cursor:pointer;}
/* Trust bar */
.trust-bar{background:#1e293b;padding:1.25rem 0;}
.trust-items{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;}
.trust-item{display:flex;align-items:center;gap:.6rem;padding:.5rem 2rem;color:#94a3b8;font-size:.8rem;font-weight:700;}
.trust-item i{color:#f97316;}
.trust-sep{width:1px;height:1.25rem;background:#334155;}
/* Common */
.section-label-param{display:inline-block;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#f97316;margin-bottom:1rem;}
.section-title{font-size:2.25rem;font-weight:900;color:#111827;line-height:1.2;margin-bottom:1rem;}
.section-sub{font-size:1.05rem;color:#6b7280;line-height:1.7;max-width:38rem;}
.param-feats{display:flex;flex-direction:column;gap:1.5rem;}
.pf-row{display:flex;gap:1.25rem;}
.pf-icon{width:2.75rem;height:2.75rem;flex-shrink:0;border-radius:.75rem;background:#f5f3ff;color:#f97316;display:flex;align-items:center;justify-content:center;font-size:1rem;}
.pf-row h4{font-size:.95rem;font-weight:800;color:#111827;margin-bottom:.4rem;}
.pf-row p{font-size:.87rem;color:#6b7280;line-height:1.6;}
/* Appareils card */
.appareils-card{background:white;border-radius:1.5rem;border:1px solid #e5e7eb;overflow:hidden;}
.ac-head{background:#f8fafc;border-bottom:1px solid #e5e7eb;padding:1rem 1.5rem;font-size:.75rem;font-weight:800;color:#64748b;text-transform:uppercase;letter-spacing:.05em;}
.ac-list{padding:.5rem 0;}
.ac-item{display:flex;align-items:center;gap:1rem;padding:.9rem 1.5rem;border-bottom:1px solid #f8fafc;}
.ac-app-icon{width:2.25rem;height:2.25rem;border-radius:.6rem;background:#f1f5f9;color:#94a3b8;display:flex;align-items:center;justify-content:center;font-size:.9rem;flex-shrink:0;}
.ac-app-icon.on-icon{background:#fff7ed;color:#f97316;}
.ac-info{flex:1;}
.ac-info b{display:block;font-size:.85rem;font-weight:800;color:#1e293b;}
.ac-info small{font-size:.7rem;color:#94a3b8;font-weight:600;}
.ac-toggle{width:2.5rem;height:1.4rem;border-radius:9999px;position:relative;flex-shrink:0;transition:background .2s;}
.ac-toggle.on{background:#f97316;}
.ac-toggle.off{background:#e5e7eb;}
.ac-thumb{position:absolute;top:2px;right:2px;width:1rem;height:1rem;background:white;border-radius:50%;transition:right .2s;}
.ac-thumb.off-thumb{right:auto;left:2px;}
/* Intervention param grid */
.interv-param-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem;}
@media(max-width:900px){.interv-param-grid{grid-template-columns:1fr;}}
.ip-col{background:white;border:1px solid #f1f5f9;border-radius:1.25rem;padding:1.5rem;}
.ip-col-head{font-size:.95rem;font-weight:800;color:#f97316;display:flex;align-items:center;gap:.5rem;margin-bottom:1.25rem;border-bottom:1px solid #f1f5f9;padding-bottom:.75rem;}
.ip-group{margin-bottom:1.1rem;}
.ip-group-name{font-size:.68rem;font-weight:800;color:#94a3b8;text-transform:uppercase;letter-spacing:.06em;margin-bottom:.4rem;}
.ip-sub{font-size:.8rem;font-weight:700;color:#374151;padding:.35rem .65rem;border-radius:.4rem;cursor:pointer;}
.ip-sub:hover{background:#f8fafc;}
.ip-add{color:#f97316;border:1px dashed #ddd6fe;font-size:.75rem;margin-top:.25rem;}
/* Points de contrôle */
.points-card{background:white;border-radius:1.25rem;border:1px solid #e5e7eb;overflow:hidden;}
.pc-head{background:#f8fafc;border-bottom:1px solid #e5e7eb;padding:1rem 1.5rem;font-size:.82rem;font-weight:800;color:#374151;display:flex;align-items:center;gap:.6rem;}
.pc-head i{color:#f97316;}
.pc-list{padding:.5rem 0;}
.pc-item{display:flex;align-items:center;gap:.75rem;padding:.75rem 1.5rem;font-size:.82rem;font-weight:700;border-bottom:1px solid #f8fafc;}
.pc-item.checked{color:#374151;}
.pc-item.checked i{color:#22c55e;}
.pc-item.unchecked{color:#94a3b8;}
.pc-item.unchecked i{color:#d1d5db;}
.pc-footer{background:#f0fdf4;padding:.85rem 1.5rem;font-size:.75rem;font-weight:700;color:#166534;display:flex;align-items:center;gap:.5rem;}
/* Tarifs */
.tarif-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1.25rem;}
@media(max-width:700px){.tarif-grid{grid-template-columns:repeat(2,1fr);}}
.tarif-card{background:white;border:1px solid #e5e7eb;border-radius:1.25rem;padding:2rem;text-align:center;}
.tarif-icon{font-size:2rem;margin-bottom:.75rem;}
.tarif-app{font-size:.85rem;font-weight:700;color:#64748b;margin-bottom:.5rem;}
.tarif-val{font-size:2rem;font-weight:900;color:#111827;margin-bottom:.15rem;}
.tarif-lab{font-size:.75rem;font-weight:700;color:#94a3b8;}
.tarif-add{border-style:dashed;color:#94a3b8;cursor:pointer;}
.tarif-add .tarif-icon{font-size:1.5rem;color:#d1d5db;}
/* Buttons */
.btn-primary-param{background:linear-gradient(to right,#f97316,#f97316);color:white;padding:1rem 2.5rem;border-radius:9999px;font-weight:800;border:none;cursor:pointer;font-size:.95rem;}
.btn-primary-large-param{background:#f97316;color:white;padding:1.2rem 3rem;border-radius:9999px;font-weight:800;border:none;font-size:1.05rem;cursor:pointer;}
.btn-outline-large{border:2px solid #e5e7eb;padding:1.2rem 3rem;border-radius:9999px;font-weight:800;color:#1f2937;text-decoration:none;display:inline-block;}
@media(max-width:1024px){.hero-param{padding-top:8rem;text-align:center;}.section-title{font-size:1.75rem;}}
</style>